import {AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import _ from 'lodash';
import {DICTIONARY} from '../../dictionary';
import {GeneralService} from '../../services/generalService';
import {RouteService} from '../../services/routeService';


@Component({
    selector: 'multi-tenant-selection-c',
    templateUrl: './multi-tenant-selection.component.html',
    styleUrls: ['./multi-tenant-selection.component.scss']
})
export class MultiTenantSelectionComponent implements OnInit, OnChanges, AfterViewInit {
    constructor(public gs: GeneralService, private rs: RouteService) {}

    @Input() planAdmins;
    @Output() onAdminSelected = new EventEmitter();
    @Output() onClose = new EventEmitter();

    dic = DICTIONARY;
    _ = _;

    searchTxt = '';

    // Filters
    planTypeFilter = '';         // '' | 'annual' | 'poc' | 'msp' | 'template'
    showSilentModeOnly = false;

    favoriteAdmins = [];
    regularAdmins = [];

    @HostListener('document:keydown.escape')
    onEscapeKey() {
        this.onClose.emit();
    }

    ngOnInit() {
        this.loadFavorites();
        this.applyFiltersAndSort();
    }

    ngAfterViewInit() {
        if (this.gs.reviewerInfo?.is_security_reviewer) {
            this.scrollToActiveAdmin();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.planAdmins && !changes.planAdmins.firstChange) {
            this.applyFiltersAndSort();
        }
    }

    loadFavorites() {
		if (this.gs.userInfo.misc?.favourites?.tenant?.length) {
			this.planAdmins.forEach((adminObj) => {
				adminObj.isFavourite = this.gs.userInfo.misc.favourites.tenant.includes(adminObj.email);
			});
		}
    }

    toggleFavorite(admin, event) {
        event.stopPropagation();
        if (admin.isFavourite) {
            this.rs.deleteUserTenantFavourite(admin.email);
			admin.isFavourite = false;
			_.pull(this.gs.userInfo.misc.favourites.tenant, admin.email);
        }
        else {
            this.rs.addUserTenantFavourite(admin.email);
			admin.isFavourite = true;
			this.gs.userInfo.misc.favourites.tenant.push(admin.email);
        }

        this.applyFiltersAndSort();
    }

    setPlanTypeFilter(type) {
        this.planTypeFilter = this.planTypeFilter === type ? '' : type;
        this.applyFiltersAndSort();
    }

    applyFiltersAndSort() {
        if (!this.planAdmins) {
            this.favoriteAdmins = [];
            this.regularAdmins = [];
            return;
        }

        let result = [...this.planAdmins];

        // Search
        if (this.searchTxt) {
            const term = this.searchTxt.toLowerCase();
            result = result.filter(a =>
                a.display_email?.toLowerCase().includes(term) ||
                a.company_name?.toLowerCase().includes(term)
            );
        }

        // Plan type / template filter
        if (this.planTypeFilter === 'template') {
            result = result.filter(a => a.isTemplate);
        }
        else if (this.planTypeFilter) {
            result = result.filter(a => !a.isTemplate && a.alloc_plan_id?.plan_sub_type === this.planTypeFilter);
        }

        // EMDR silent mode filter
        if (this.showSilentModeOnly) {
            result = result.filter(a => a.alloc_plan_id?.emdr?.is_silent_mode);
        }

        this.favoriteAdmins = result.filter(admin => admin.isFavourite);
        this.regularAdmins = result.filter(admin => !admin.isFavourite);
    }

    scrollToActiveAdmin() {
        // CC: wait for virtual-scroller to paint the active row before scrolling
        setTimeout(() => {
            const container = document.querySelector('.mts-list-container');
            if (!container) {
                return;
            }
            const active = container.querySelector('.is-active-admin');
            if (!active) {
                return;
            }
            // CC: scroll only the tenant list container (avoid scrolling the page)
            const containerRect = container.getBoundingClientRect();
            const activeRect = active.getBoundingClientRect();
            container.scrollTop += activeRect.top - containerRect.top - (container.clientHeight / 2) + (activeRect.height / 2);
        });
    }

    selectAdmin(admin) {
        this.onAdminSelected.emit(admin);
    }
}
